// extracted by mini-css-extract-plugin
export default {"root":"checkbox-default-theme__root","checkmark":"checkbox-default-theme__checkmark","error":"checkbox-default-theme__error"};